import { Grid } from '@mui/material'
import { CustomInput, CustomTextArea } from 'src/consumer/components/helperComponents'
import PrescriptionSectionCard from './PrescriptionSectionCard'

/**
 * Section for clinic contact details
 * Handles website, email, phone, and address fields
 */
export default function ClinicDetailsSection({ prescriptionTemplate, handleChange }) {
  return (
    <PrescriptionSectionCard heading="Clinic Details">
      <Grid item xs={12}>
        <CustomInput
          id="website"
          value={prescriptionTemplate?.website}
          label="Website"
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomInput
          id="contactEmail"
          value={prescriptionTemplate?.contactEmail}
          label="Contact Email"
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomInput
          id="contactNumber"
          value={prescriptionTemplate?.contactNumber}
          label="Contact Phone Number"
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomTextArea
          id="contactAddress"
          value={prescriptionTemplate?.contactAddress}
          label="Contact Address"
          colNumber={12}
          rows={2}
          onChange={handleChange}
        />
      </Grid>
    </PrescriptionSectionCard>
  )
}
